// Lib
import React, { ReactElement } from 'react';

// Util
import { getListChildNewLocation } from '../../../../../common/elements/utils/elementLocationUtils';

// Components
import Icon from '../../../../components/icons/Icon';
import ToolbarTool from '../../../../workspace/toolbar/components/ToolbarTool';
import FileUploadForm from '../../../../components/tools/files/FileUploadForm';

// Constants
import { ELEMENT_CREATION_SOURCES } from '../../../../../common/elements/elementConstants';

// Types
import { ToolbarItemsListRequiredProps } from '../../../../workspace/toolbar/components/ToolbarItemsList';

type MobileImageToolProps = ToolbarItemsListRequiredProps;

const getElementLocation = ({ currentBoardId }: MobileImageToolProps) =>
    getListChildNewLocation({ listId: currentBoardId });

const MobileImageTool = (props: MobileImageToolProps): ReactElement => {
    return (
        <FileUploadForm
            {...props}
            getElementLocation={getElementLocation}
            creationSource={ELEMENT_CREATION_SOURCES.MOBILE_UPLOAD}
        >
            {(openFileInput: () => void) => (
                <ToolbarTool className="MobileImageTool" name="Image" onClick={openFileInput}>
                    <Icon name="toolbar-camera" />
                </ToolbarTool>
            )}
        </FileUploadForm>
    );
};

export default MobileImageTool;
